import React from 'react';
import Typography, {TypographyProps} from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import useStyles from './EulaItem.styles';
import {Eula} from '../../../reducers/eula.reducer';
import {ParagraphSkeleton} from '../..';
import {Skeleton} from '@material-ui/lab';
import {dateFormatUTC} from '../../../../shared/utils/DateUtils';
import Message from '../../common/Message';

export interface Props {
    isLoading?: boolean;
    item: Partial<Eula>;
    titleProps?: TypographyProps;
}

const CODES = {
    lastUpdated: 'epic.affiliate.common.time.last_updated'
};

const EulaItem: React.FC<Props> = ({isLoading, item, titleProps}) => {
    const styles = useStyles();
    const {key, title, body, lastModifiedTimestamp} = item || {};
    return (
        <Box key={key}>
            <Typography
                className={styles.eulaTitle}
                variant="h2"
                color="textPrimary"
                align="center"
                {...titleProps}>
                {isLoading || !title ? <Skeleton height={100} /> : title}
            </Typography>
            <Typography
                className={styles.lastUpdated}
                variant="caption"
                color="textSecondary"
                align="center"
                component="div">
                {isLoading || !lastModifiedTimestamp ? (
                    <Skeleton height={20} width={100} />
                ) : (
                    <em>
                        <Message
                            code={CODES.lastUpdated}
                            args={[dateFormatUTC(lastModifiedTimestamp)]}
                        />
                    </em>
                )}
            </Typography>
            <Typography
                className={styles.eulaBody}
                component="div"
                color="textSecondary"
                variant="body2">
                {isLoading || !body ? (
                    <>
                        <ParagraphSkeleton />
                        <ParagraphSkeleton />
                        <ParagraphSkeleton type="sma" />
                        <ParagraphSkeleton type="smb" />
                    </>
                ) : (
                    <div dangerouslySetInnerHTML={{__html: body}} />
                )}
            </Typography>
        </Box>
    );
};

export default React.memo(EulaItem);
